import { useRouter } from "next/router";

import { useGetProfileId } from "_common/hooks/auth";
import {
	UPLOAD_TYPE_CONFIG,
	uploadingStates,
	useGetIsUploadingVideo,
	useGetPercentCompletedAtom,
	useGetUploadThumbnailUrl,
	useGetUploadTypeAtom
} from "_common/hooks/uploadVideo";
import FetchMore               from "_components/atoms/fetchMoreLoader";
import Image                   from "_components/atoms/image";
import TabEmptyState           from "_components/atoms/tabEmptyState";
import UploadThumbnailSkeleton from "_components/atoms/uploadThumbnailSkeleton/container";
import UploadMenuItem          from "_components/molecules/uploadMenuItem";
import ImagesTab               from "_components/organisms/imagesTab";
import VideoCardList           from "_components/organisms/videoCardList";

import CreatorPlusComponent from "../creatorPlusComponents";
import { tabList }          from "../utils";

import useStyles from "./styles";

const component = ( {
	activeTab,
	deletionTime,
	isDepleted,
	isLoading,
	isLoadingStreams,
	list = [],
	fetchMore,
	streamsToDelete = [],
	totalNoOfStreams = 0,
	updateDeletedPost,
	uploadType
} ) => {

	return (
		<FeedList
			activeTab         = { activeTab }
			deletionTime      = { deletionTime }
			fetchMore         = { fetchMore }
			isDepleted        = { isDepleted }
			isLoading         = { isLoading }
			isLoadingStreams  = { isLoadingStreams }
			list              = { list }
			streamsToDelete   = { streamsToDelete }
			totalNoOfStreams  = { totalNoOfStreams }
			updateDeletedPost = { updateDeletedPost }
			uploadType        = { uploadType }
		/>
	);
};

export default component;

function FeedList ( {
	activeTab,
	deletionTime,
	isDepleted,
	isLoading,
	isLoadingStreams,
	list = [],
	fetchMore,
	streamsToDelete = [],
	totalNoOfStreams = 0,
	updateDeletedPost
} ) {

	const isUploadingVideo = useGetIsUploadingVideo ();

	const startingComponent = () => <VideoProcessing activeTab = { activeTab } />;

	// if list is empty
	if ( !list.length && !isLoading ) {
		// but we are uploading a reel or a video
		if ( isUploadingVideo === uploadingStates.UPLOADING
		&& ( activeTab === "reels" || activeTab === "videos" ) )
			return (
				<VideoCardList
					activeTab         = { activeTab }
					cardType          = { "video" }
					list              = { list }
					startingComponent = { startingComponent }
				/>
			);

		// return empty state if there is no active upload and list is also empty
		return <TabEmptyState />;
	}

	// return feedList for streams
	if ( activeTab === tabList[0].value ) {
		return (
			<>
				{!isLoadingStreams && streamsToDelete.length > 0 && (
					<CreatorPlusComponent
						deletionTime     = { deletionTime }
						streamsToDelete  = { streamsToDelete }
						totalNoOfStreams = { totalNoOfStreams }
					/>
				)}

				<VideoCardList
					activeTab         = { activeTab }
					cardType          = { "stream" }
					list              = { list }
					startingComponent = { null }
				/>

				<FetchMore
					fetchMore  = { fetchMore }
					isDepleted = { isDepleted }
					isLoading  = { isLoading }
				/>
			</>
		);
	}

	// return feed list for  videos
	if ( activeTab === tabList[1].value ) {

		return (
			<>
				<VideoCardList
					activeTab         = { activeTab }
					cardType          = { "video" }
					list              = { list }
					startingComponent = { startingComponent }
				/>

				<FetchMore
					fetchMore  = { fetchMore }
					isDepleted = { isDepleted }
					isLoading  = { isLoading }
				/>
			</>
		);
	}

	// return feed list for reels
	if ( activeTab === tabList[2].value ) {
		return (
			<>
				<VideoCardList
					activeTab         = { activeTab }
					cardType          = { "reel" }
					from              = { "profileReelTab" }
					list              = { list }
					startingComponent = { startingComponent }
				/>

				<FetchMore
					fetchMore  = { fetchMore }
					isDepleted = { isDepleted }
					isLoading  = { isLoading }
				/>
			</>
		);

	}

	if ( activeTab === tabList[3].value ) {
		return (
			<ImagesTab
				getNextData       = { fetchMore }
				imageList         = { list }
				isDataDepleted    = { isDepleted }
				isFetchingData    = { isLoading }
				updateDeletedPost = { updateDeletedPost }
				verticalFeedType  = "report-only"
			/>
		);
	}

	return null;
}
/* async function getFeedData ( feedId, tab ) {
	try {
		const val = await getFeedById ( { feedId } );

		return val;
	} catch ( error ) {
		toast.error ( error.displayMsg || "Something went wrong!" );
	}
} */

export const VideoProcessing = ( { activeTab, cardType } ) => {
	const router = useRouter ();

	const { id/* , tab */ } = router.query;

	const isUploadingVideo = useGetIsUploadingVideo ();
	const uploadType       = useGetUploadTypeAtom ();
	const percentCompleted = useGetPercentCompletedAtom ();
	// const videoDetails     = useGetInProgressVideoDetails ();
	const thumbnail = useGetUploadThumbnailUrl ();

	// const { data, error } = useSWR ( Math.floor ( percentCompleted ) === 100 ? null : "/getFeedDataById", () => getFeedData ( videoDetails.feedId, tab ) );

	const ownProfileId = useGetProfileId ();
	const isOwnProfile = parseInt ( id ) === parseInt ( ownProfileId );

	const { classes } = useStyles ( { cardType }, { name: "videoProcessing" } );

	if ( !isOwnProfile ) return null;
	if ( isUploadingVideo !== uploadingStates.UPLOADING ) return null;

	if ( activeTab === "reels" && uploadType === "video" ) return null;
	if ( activeTab === "videos" && uploadType === "reel" ) return null;

	let activeUploadType = "video";

	if ( activeTab === "reels" && uploadType === UPLOAD_TYPE_CONFIG.REELS )
	  activeUploadType = "reel";

	if ( activeTab === "videos" && uploadType === UPLOAD_TYPE_CONFIG.VIDEOS )
		activeUploadType = "video";

	return (
		<div className = { classes.processingVideoContainer }>
			{thumbnail ? (
				<Image
					className = { classes.thumbnail }
					src       = { thumbnail }
					type      = "hdpi"
				/>
			) : (
				<UploadThumbnailSkeleton
					aspectRatio = {
						activeUploadType === "reel" ? "9/16" : "16/9"
					}
				/>
			)}

			<div className = { classes.contentContainer }>
				<UploadMenuItem
					hideThumbnailFromAvatarMenu
					progress = { percentCompleted }
				/>
			</div>
		</div>
	);

/* if ( data && !error )
		return (
			<VideoCard
				activeTab = { uploadType }
				data      = { data }
			/>
		); */
};
